export function Separator() {
  return <hr className="text-gray-210 dark:text-gray-45" />;
}
